import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import SideNav from '../component/um/agenda/SideNav'
import EditAgendaTab from '../component/um/agenda/EditAgendaTab'
import EditMinutesTab from '../component/um/agenda/EditMinutesTab'
import { useSettingAgendas } from '../services/um/useSettingAgendas'
import useLoading from '../control/loading/useLoading'
import { AgendaFolder, AgendaTabKey } from '../component/um/agenda/agendaTypes'
import useAuthenStore from '../stores/authen/authenStore'

function useQueryTab(defaultTab: AgendaTabKey = 'agenda') {
    const [tab, setTab] = useState<AgendaTabKey>(() => {
        const url = new URL(window.location.href)
        return (url.searchParams.get('tab') || defaultTab) as AgendaTabKey
    })
    const update = (newTab: AgendaTabKey) => {
        setTab(newTab)
        const url = new URL(window.location.href)
        url.searchParams.set('tab', newTab)
        window.history.replaceState(null, '', url.toString())
    }
    return [tab, update] as const
}

const EditAgenda = () => {
    const authenStore = useAuthenStore()
    const classes = useStyles()
    const loading = useLoading()
    const { id } = useParams<{ id: string }>()

    const { getAgendaFolderById } = useSettingAgendas()

    const [tab, setTab] = useQueryTab('agenda')
    const [open, setOpen] = useState(false)
    const [folderData, setFolderData] = useState<AgendaFolder>()

    const fetchAgendaFolder = useCallback(async () => {
        loading.loadingOpen()
        try {
            const res = await getAgendaFolderById(String(authenStore?.profile?.irb), id)
            const data = res?.result
            if (!data) return
            setFolderData(data)
        } finally {
            loading.loadingClose()
        }
    }, [getAgendaFolderById, id, loading])

    useEffect(() => {
        fetchAgendaFolder()
    }, [tab, id])

    return (
        <div className={classes.root}>
            <Box className={classes.layout} style={{ border: 0 }}>
                <SideNav
                    open={open}
                    tab={tab}
                    onToggle={() => setOpen((val) => !val)}
                    canUseAgendaReport={
                        folderData?.canCreateReport || Number(folderData?.agenda?.submittedStatusId) === 8
                    }
                    onSelect={setTab}
                />
                <Box className={classes.contentWrap}>
                    {tab === 'agenda' && <EditAgendaTab />}
                    {tab === 'minutes' && folderData && (
                        <EditMinutesTab
                            canShow={folderData?.canCreateReport || Number(folderData?.agenda?.submittedStatusId) === 8}
                            agendaReportId={folderData?.agendaReport?.agendaReportId}
                            onComplete={fetchAgendaFolder}
                        />
                    )}
                </Box>
            </Box>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    root: { display: 'flex', maxWidth: 1320, margin: '24px auto', padding: theme.spacing(0, 2), width: '100%' },
    contentWrap: { flexGrow: 1 },
    layout: { display: 'grid', gridTemplateColumns: 'auto 1fr', width: '100%' },
    emptyWrap: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 250,
        borderRadius: 12,
        border: '1px solid rgba(0,0,0,0.08)',
    },
}))

export default EditAgenda
